<article *ngIf="statusList[0]?.comment && !isAutomation " class="sectional-status-warning d-flex p-3">
  <img src="/assets/icons/common/excla.svg">
  <span class="ms-3 font-semi-bold">{{statusList[0]?.comment}}</span>
</article>